import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const JobTitleDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Job Title"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Job Title">
                {getFieldDecorator('jobTitle', {
                 initialValue: data.jobTitle,
                  rules: [{ required: true, message: 'Please input the Job Title!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default JobTitleDialogForm;
